import { Organization } from "../../defines/organizations";
import { QueryData, ResponseData } from "../services/network/NetworkTypes";

export default class Profile {
  public orgLogo?: string;

  constructor(
    public id: string,
    public firstName: string,
    public middleName: string,
    public lastName: string,
    public email: string,
    public organization: Organization,
    public createdOn: Date,
    public modifiedOn: Date
  ) {}

  static fromJSON(json: any): Profile {
    /*
          {
            "id": "4756db0e-d08b-4de1-8a27-8e9b9a24565d",
            "email": "ivanchyk@unicc.org",
            "created": "2025-02-19T11:07:01.003696Z",
            "modified": "2025-02-19T11:07:01.003696Z",
            "first_name": "Alex",
            "middle_name": null,
            "last_name": "Ivanchyk",
            "organization_acronym": "UNICC"
          }
    */
    return new Profile(
      json.id,
      json.first_name,
      json.middle_name,
      json.last_name,
      json.email,
      json.organization_acronym,
      json.created,
      json.modified
    );
  }

  toJSON(): ProfileUpdateData {
    return {
      id: this.id,
      first_name: this.firstName,
      middle_name: this.middleName,
      last_name: this.lastName,
      email: this.email,
      organization: this.organization,
    };
  }
}

export type ProfileCreateData = {
  first_name: string;
  middle_name: string;
  last_name: string;
  email: string;
  organization: Organization;
};

export type ProfileUpdateData = Partial<ProfileCreateData> & {
  id: string;
};

// This will be used to filter the data
export type ProfilesDataFilter = "search";
// Backend keys you can sort with
export type ProfileDataOrder =
  | "first_name"
  | "middle_name"
  | "last_name"
  | "email"
  | "organization";

// This will help transform the sorting from local to backend keys.
export const profileDataOrderTransform: Record<string, ProfileDataOrder> = {
  firstName: "first_name",
  lastName: "last_name",
  middleName: "middle_name",
};

// These are the keys used for table listings
export type ProfileDataTableFields = keyof typeof profileDataOrderTransform;

export type ProfileQueryData = QueryData<ProfilesDataFilter, ProfileDataOrder>;
export type ProfileResponseData = ResponseData<
  Profile,
  ProfilesDataFilter,
  ProfileDataOrder
>;

export type ProfileWithPublicKey = Required<Profile>;
